module.exports = __webpack_public_path__ + "static/media/thumbnailNumbers.1232b836.jpg";